import React from 'react';
import {createRoot} from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import ClimateChangeApp from './ClimateChangeApp';


import "./app/config/i18nextInt";

import './resources/sass/index.scss';

const root = createRoot(document.getElementById('root'));
root.render(<ClimateChangeApp  />);

reportWebVitals();
